import { queryOptions } from "@tanstack/react-query"
import {
  GatedReceiptPOSTRequest,
  GatedRegisterSessionPOSTRequest,
} from "ipctg-inflow-types/InFlowGatedAPI"

import api from "@/utilities/api"

import {
  GatedReceiptError,
  GatedRegisterSessionError,
  GatedWelcomeError,
} from "@/utilities/expectedErrors"
import { WelcomeToken } from "@/utilities/types/local"
import WelcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

import { RECEIPT_BASE_KEY, REGISTER_BASE_KEY, SHARED_BASE_KEY } from "./keys"

export async function fetchWelcomeToken(args: { qrLookupID: string }) {
  const rsp = await api.welcome.POST({ qr: args.qrLookupID })

  if ("failReason" in rsp) {
    throw new GatedWelcomeError(rsp.failReason)
  }

  const newWelcomeToken: WelcomeToken = {
    qrLookupID: args.qrLookupID,
    token: rsp.token,
  }
  WelcomeTokenStorage.setSessionData(newWelcomeToken)
  return newWelcomeToken
}

export const registerQueryOptions = (args: GatedRegisterSessionPOSTRequest) => {
  return queryOptions({
    queryKey: [SHARED_BASE_KEY, REGISTER_BASE_KEY, args],
    queryFn: async () => {
      const rsp = await api.registerSession.POST({ ...args })

      if ("failReason" in rsp) {
        throw new GatedRegisterSessionError(rsp.failReason)
      }

      return rsp
    },
    retry: false,
  })
}

export const receiptQueryOptions = (args: GatedReceiptPOSTRequest) => {
  return queryOptions({
    queryKey: [SHARED_BASE_KEY, RECEIPT_BASE_KEY, args],
    queryFn: async () => {
      const rsp = await api.receipt.POST({ receiptID: args.receiptID })
      if ("failReason" in rsp) {
        throw new GatedReceiptError(rsp.failReason)
      }
      return rsp
    },
    retry: false,
  })
}
